import { TriangleAlert } from "lucide-react";
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/user.reducer";
import { useNavigate } from "react-router-dom";

export default function LogoutModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleLoginAgain() {
    dispatch(logout());
    navigate("/login");
  }

  return (
    <div className="bg-black/70 font-mulish absolute z-50 w-screen h-screen flex items-center justify-center">
      <div className="modal rounded-md shadow-xl text-center bg-white max-w-md mx-4">
        <div className="p-6">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">Your session has expired</h3>
          <p className="text-gray-600 mb-6">
            You have been logged out due to inactivity. Please login again.
          </p>
          <button
            onClick={handleLoginAgain}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-md transition-colors duration-200"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
}
